import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface VolunteerFest {
    id: string;
    name: string;
    status: string;
    startDate: string;
    endDate: string;
    logo?: string | null;
}

interface VolunteerState {
    selectedFest: VolunteerFest | null;
}

const initialState: VolunteerState = {
    selectedFest: null,
};

const volunteerSlice = createSlice({
    name: 'Volunteer',
    initialState,
    reducers: {
        setSelectedVolunteerFest(state, action: PayloadAction<VolunteerFest>) {
            state.selectedFest = action.payload;
        },
        clearSelectedVolunteerFest(state) {
            state.selectedFest = null;
        },
    },
});

export const { setSelectedVolunteerFest, clearSelectedVolunteerFest } = volunteerSlice.actions;
export default volunteerSlice.reducer;
